import {
  Box,
  createStyles,
  makeStyles,
  TextField,
  Theme,
  InputAdornment,
  alpha,
} from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';

export interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export const SearchBar = ({ value, onChange, placeholder }: SearchBarProps) => {
  const classes = useStyles();

  return (
    <Box className={classes.search}>
      <TextField
        type="search"
        className={classes.input}
        placeholder={placeholder || 'Search'}
        onChange={(e) => onChange && onChange(e.target.value ? e.target.value : '')}
        focused
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <FontAwesomeIcon icon={faSearch} className={classes.searchIcon} />
            </InputAdornment>
          ),
          disableUnderline: true,
        }}
      />
    </Box>
  );
};
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    search: {
      display: 'flex',
      width: '100%',
      alignItems: 'center',
      borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
    },
    input: {
      position: 'relative',
      width: '100%',
      variant: 'outlined',
      '& .MuiInputBase-input': {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        padding: '12px 25px 12px 48px',
        fontSize: 14,
        '::placeholder': {
          color: theme.palette.text.secondary,
          opacity: 1,
        },
      },
      '& input': {
        backgroundColor: `${theme.palette.background.paper} !important`,
      },
    },
    searchIcon: {
      position: 'absolute',
      left: 25,
      fontSize: 16,
      zIndex: 2,
      color: theme.palette.text.secondary,
    },
  })
);
